module.exports = __webpack_public_path__ + "static/media/background_1920-7.abf47fc1.png";